import { ButtonType } from '@src/types.ts';
import { useTranslation } from 'react-i18next';
import Dialog from '@components/modals/Dialog.tsx';
import success from '@assets/success.png';

export function JobCreatedModal({
  open,
  setOpen,
}: Readonly<{
  open: boolean;
  setOpen: (open: boolean) => void;
}>) {
  const { t } = useTranslation('jobCreatedModal');
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={''}
      actions={[
        {
          buttonProps: {
            label: t('close'),
            buttonType: ButtonType.BLACK,
            onClick: () => setOpen(false),
            testId: 'closeButton',
          },
        },
      ]}
      actionContainerClassNames="!flex justify-center"
      testId={'jobCreatedModal'}
    >
      <div className="text-center md:w-115">
        <div className="flex justify-center mb-6">
          <img
            src={success}
            alt="success"
            className="h-28 w-28 text-darkGreen"
          />
        </div>
        <p className="font-medium text-[32px]/[40px]">{t('success')}</p>
        <p className="mt-4">{t('successMessage')}</p>
      </div>
    </Dialog>
  );
}
